import React from 'react';
import { IconProps } from '../types';

const ChevronUpIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M18 15l-6-6-6 6" />
    </svg>
  );
};

export default ChevronUpIcon;
